module.exports = __webpack_public_path__ + "img/hero-10.eb1587c8.png";